const daysAfterNow = numOfDays => {
  return new Date().setDate(new Date().getDate() + numOfDays)
}

export default daysAfterNow
